import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CountrySelection from '../../guest-payment-components/CountrySelection';
import CreateAccountTile from './createAccountTile';
import CancelAndReturn from '../../components/cancelAndReturn';

class RussiaGuestForm extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="donate_guest_form_wrapper">
        <div className="ppvx_row">
          <div className="ppvx_col-sm-12 text-center">
            <CountrySelection
              supportedCountries={this.props.supportedCountries}
              defaultValue={this.props.currentCountry}
              changeCountry={this.props.changeCountry}
              label={this.props.countryLabel}
            />
          </div>
        </div>

        <CreateAccountTile />

        <CancelAndReturn />
      </div>
    );
  }
}

RussiaGuestForm.propTypes = {
  supportedCountries: PropTypes.array,
  currentCountry: PropTypes.string,
  changeCountry: PropTypes.func,
  countryLabel: PropTypes.string,
};

export default RussiaGuestForm;
